var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressTracker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0008 3.78947C18.0008 4.77777 17.1997 5.57895 16.2113 5.57895C15.223 5.57895 14.4219 4.77777 14.4219 3.78947C14.4219 2.80117 15.223 2 16.2113 2C17.1997 2 18.0008 2.80117 18.0008 3.78947Z",
    stroke: "white",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0794 8.17864C17.1053 8.96988 17.1053 9.88413 17.1053 10.9472C17.1053 14.7432 17.1053 16.6413 15.926 17.8205C14.7467 18.9998 12.8486 18.9998 9.05263 18.9998C5.25659 18.9998 3.35856 18.9998 2.17928 17.8205C1 16.6413 1 14.7432 1 10.9472C1 7.15112 1 5.25309 2.17928 4.07381C3.35856 2.89453 5.25659 2.89453 9.05263 2.89453C10.1157 2.89453 11.0299 2.89453 11.8211 2.92043",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57812 12.7367L7.07703 10.2378C7.42645 9.88836 7.99298 9.88836 8.34237 10.2378L9.76125 11.6566C10.1106 12.006 10.6772 12.006 11.0266 11.6566L13.5255 9.15771",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressTracker);
export default __webpack_public_path__ + "static/media/progressTracker.e98807c3af43da8f21b3ed4b43664978.svg";
export { ForwardRef as ReactComponent };